import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { ProfileItem } from 'qp-ui-interface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NavigationLibraryService } from '../../services/navigation/navigation.service';
import { UserStateService } from '../../services/user-state/user-state.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent implements AfterViewInit, OnDestroy {
  profile: ProfileItem;
  show: boolean;
  private destroy$ = new Subject<void>();
  constructor(private userState: UserStateService, private navService: NavigationLibraryService) {
    this.userState.loading.pipe(takeUntil(this.destroy$)).subscribe((isLoading) => {
      this.show = isLoading;
    });
    this.userState.selectedProfile.pipe(takeUntil(this.destroy$)).subscribe((profile) => {
      this.profile = profile;
    });
  }
  async ngAfterViewInit() {
    this.navService.focusContainer('profiles-list', true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
